import View from '@play-co/timestep-core/lib/ui/View';
import { Feature } from 'src/replicant/analytics';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import { MarketingEventID } from 'src/replicant/airtable/marketing.types';
import { getMarketingEventById } from 'src/replicant/marketing/marketing.getters';
import PopupRewardsChest from './PopupRewardsChest';

export default class PopupMarketingRewards extends PopupRewardsChest {
  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      tracking: {
        feature: Feature.MARKETING._,
        $subFeature: Feature.MARKETING.COLLECT,
      },
    });
  }

  public init(opts: { eventId: MarketingEventID }) {
    const { gems, coins } = getMarketingEventById(opts.eventId)?.rewards || {};
    const rewards: Match2Reward[] = [];
    if (gems) {
      rewards.push({
        type: 'gems',
        amount: gems,
      });
    }

    if (coins) {
      rewards.push({
        type: 'bPoints',
        amount: coins,
      });
    }

    super.init({ rewards });
  }
}
